var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShown)?_c('div',{staticClass:"scroll-to-top-button",class:[
    {'scroll-to-top-button--show': _vm.scroll > 150}
  ],on:{"click":_vm.scrollToTop}},[_c('r-icon',{attrs:{"icon":"arrow-bold-up","fill":"harakiri","size":"16"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }